import React, { createContext, useContext, useState, useCallback } from 'react';
import { LoginRequiredModal } from '../components/LoginRequiredModal';
import { useNotification } from '../components/member/NotificationProvider';

interface LoginPromptContextType {
  openLoginPrompt: (featureName?: string) => void;
  closeLoginPrompt: () => void;
  isPromptOpen: boolean;
  featureName: string;
}

const LoginPromptContext = createContext<LoginPromptContextType | undefined>(undefined);

export const LoginPromptProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [featureName, setFeatureName] = useState('esta funcionalidade');
  const { showNotification } = useNotification();

  const openLoginPrompt = useCallback((name?: string) => {
    const targetName = name || 'esta funcionalidade';
    setFeatureName(targetName);
    setIsOpen(true);
    showNotification(`Você precisa fazer login para ter acesso a ${targetName}.`, 'info');
  }, [showNotification]);

  const closeLoginPrompt = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <LoginPromptContext.Provider value={{ openLoginPrompt, closeLoginPrompt, isPromptOpen: isOpen, featureName }}>
      {children}
      <LoginRequiredModal
        isOpen={isOpen}
        onClose={closeLoginPrompt}
        featureName={featureName}
      />
    </LoginPromptContext.Provider>
  );
};

export const useLoginPrompt = (): LoginPromptContextType => {
  const context = useContext(LoginPromptContext);
  if (!context) {
    throw new Error('useLoginPrompt must be used within a LoginPromptProvider');
  }
  return context;
};
